import React, { useState, useEffect } from 'react';
import { Row, Col } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Select, { components } from "react-select";
import "./inputbox.css";

// REQUIRED SPECIAL RENDERING INPUTS IMPORTS
import { RequiredCheckboxes } from './requiredcheckboxes';
import { RequiredSelect } from './requiredselect';

// This mapper is used to render the selected option on input boxes when rerender happens
const INPUT_OPTION_MAPPER = {
    "text": {
        value: "text",
        label: "Text",
        id: "text",
        logo: <Icon.TextParagraph style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "password": {
        value: "password",
        label: "Password",
        id: "password",
        logo: <Icon.Key style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "numberinput": {
        value: "numberinput",
        label: "Number",
        id: "numberinput",
        logo: <Icon.Icon123 style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "checkbox": {
        value: "checkbox",
        label: "Checkbox",
        id: "checkbox",
        logo: <Icon.Check2Square style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "select": {
        value: "select",
        label: "Dropdown",
        id: "select",
        logo: <Icon.MenuButtonWide style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "radio": {
        value: "radio",
        label: "Choice",
        id: "radio",
        logo: <Icon.UiRadiosGrid style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "date": {
        value: "date",
        label: "Date",
        id: "date",
        logo: <Icon.Calendar2Date style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "header": {
        value: "header",
        label: "Title",
        id: "header",
        logo: <Icon.Fonts style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
    "file": {
        value: "file",
        label: "File",
        id: "file",
        logo: <Icon.FileEarmarkMedical style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
    },
}

const InputBox = (props) => {
    const [label, setLabel] = useState(props.existingfieldschema.length > 0 ? props.existingfieldschema[0].label : "Untitled")
    const [activeToggle, setActiveToggle] = useState(false);
    const [fieldId, setFieldId] = useState(props.inputboxid)
    const [fieldSchema, setFieldSchema] = useState(props.existingfieldschema)
    const [selectedInput, setSelectedInput] = useState(props.existingfieldschema.length > 0 ? INPUT_OPTION_MAPPER[props.existingfieldschema[0].type] : INPUT_OPTION_MAPPER["text"])
    const [selectedWidth, setSelectedWidth] = useState()
    const [selectedHeader, setSelectedHeader] = useState()
    const [INPUT_MAP, SET_INPUT_MAP] = useState({ "text": "" })

    /**
     * Update the properties of INPUT_MAP everytime the field schema and field id changes
     */
    useEffect(() => {
        SET_INPUT_MAP(
            {
                "header": "",
                "text": "",
                "numberinput": "",
                "password": "",
                "checkbox": <RequiredCheckboxes
                    baseid={fieldId}
                    fieldschema={fieldSchema}
                    addnewcomponent={(component) => AddNewComponentsToPreview(component)}
                    updatecomponent={(field, key, value) => UpdateComponentToPreview(field, key, value)}
                    removecomponent={(component) => RemoveComponentToPreview(component, false)}
                />,
                "select": <RequiredSelect
                    baseid={fieldId}
                    selectschema={fieldSchema}
                    updatecomponent={(field, key, value) => UpdateComponentToPreview(field, key, value)}
                    removecomponent={(field) => RemoveComponentToPreview(field, false)}
                />,
                "date": "",
                "file": ""
            }
        )
    }, [fieldId, fieldSchema])

    /**
     * Update the parent schema is current schema is updated and ot same as parent schema
     */
    useEffect(() => {
        if (props.existingfieldschema !== fieldSchema) {
            props.updatefieldschema(fieldSchema)
        }
    }, [fieldSchema])

    /**
     * Based on selected input update the current schema
     */
    useEffect(() => {
        const index = fieldSchema.findIndex((obj) => obj.id === fieldId)
        const updatedActiveInputBox = [...fieldSchema]
        updatedActiveInputBox[index]["type"] = selectedInput.value
        setFieldSchema(updatedActiveInputBox)
    }, [selectedInput])

    // Setting default INPUT select options
    const [inputOptions, setInputOptions] = useState([
        {
            label: "Headings",
            options: [
                {
                    value: "header",
                    label: "Title",
                    id: "header",
                    logo: <Icon.Fonts style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
                }]
        },
        {
            label: "Inputs",
            options: [{
                value: "text",
                label: "Text",
                id: "text",
                logo: <Icon.TextParagraph style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
            {
                value: "password",
                label: "Password",
                id: "password",
                logo: <Icon.Key style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
                ,
            {
                value: "numberinput",
                label: "Number",
                id: "numberinput",
                logo: <Icon.Icon123 style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
            {
                value: "checkbox",
                label: "Checkbox",
                id: "checkbox",
                logo: <Icon.Check2Square style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
            {
                value: "select",
                label: "Dropdown",
                id: "select",
                logo: <Icon.MenuButtonWide style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
            {
                value: "date",
                label: "Date",
                id: "date",
                logo: <Icon.Calendar2Date style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            },
            {
                value: "file",
                label: "File",
                id: "file",
                logo: <Icon.FileEarmarkMedical style={{ fontSize: 20, color: "var(--theme1_primary)" }} />
            }]
        }
    ])

    // Setting default WIDTH select options
    const [widthOptions, setWidthOptions] = useState([
        {
            value: "12",
            label: "100%",
            id: "12"
        },
        {
            value: "9",
            label: "75%",
            id: "9"
        },
        {
            value: "8",
            label: "66%",
            id: "8"
        },
        {
            value: "6",
            label: "50%",
            id: "6"
        },
        {
            value: "4",
            label: "33%",
            id: "4"
        },
        {
            value: "3",
            label: "25%",
            id: "3"
        }
    ])

    // Setting HEADER select options for TITLE input type
    const [headerOptions, setHeaderOptions] = useState([
        {
            value: "H1",
            label: <p style={{ fontSize: 20 }}>Heading 1</p>,
            id: "H1",
        },
        {
            value: "H2",
            label: <p style={{ fontSize: 18 }}>Heading 2</p>,
            id: "H2",
            fontSize: 20
        },
        {
            value: "H3",
            label: <p style={{ fontSize: 16 }}>Heading 3</p>,
            id: "6",
            fontSize: 20
        },
        {
            value: "H4",
            label: <p style={{ fontSize: 14 }}>Heading 4</p>,
            id: "H4",
            fontSize: 20
        },
        {
            value: "H5",
            label: <p style={{ fontSize: 12 }}>Heading 5</p>,
            id: "H5",
            fontSize: 20
        },
        {
            value: "H6",
            label: <p style={{ fontSize: 10 }}>Heading 6</p>,
            id: "H6",
            fontSize: 10
        }
    ])

    // Custom react select option renderer
    const { Option, Control } = components;

    /**
     * Render option with logo and then title
     * @param {*} props: defined select props 
     * @returns: custom select option
     */
    const IconOption = props => {
        return (
            <Option {...props}>
                {props.data.logo} &nbsp;&nbsp;&nbsp;&nbsp;
                {props.data.label}
            </Option>
        )
    };

    /**
     * Icon option render controller
     * @param {*} param0: custom select option params
     * @returns: custom selected option 
     */
    const IconControl = ({ children, ...props }) => {
        return (
            <Control {...props}>
                &nbsp;&nbsp;&nbsp;&nbsp;
                {props.selectProps.value.logo} &nbsp;&nbsp;
                {children}
            </Control>
        );
    };

    /**
     * Add the provided component to current schema
     * @param {*} component: Field component
     */
    const AddNewComponentsToPreview = (component) => {
        setFieldSchema((fieldSchema) => [...fieldSchema, component])
    }

    /**
     * Update the property of field component inside the current schema with provided value
     * @param {*} field: Field component 
     * @param {*} key: The property to be changed
     * @param {*} value: The entered value in input field
     */
    const UpdateComponentToPreview = (field, key, value) => {
        const updatedComponents = [...fieldSchema]
        const index = updatedComponents.findIndex(q => q.id === field.id);
        if (index !== -1) {
            updatedComponents[index][key] = value;
        }
        setFieldSchema(updatedComponents)
    }

    /**
     * Remove the provided component from schema if inputboxflag is false else just remove the input box with all its field components
     * @param {*} field: Field component
     * @param {*} inputboxflag: Flag to control behaviour
     */
    const RemoveComponentToPreview = (field, inputboxflag) => {
        if (inputboxflag === true) {
            props.removeinputbox(fieldId)
        } else {
            const updatedComponents = [...fieldSchema]
            const index = updatedComponents.findIndex((obj) => obj.id === field.id)
            if (index !== -1) {
                updatedComponents.splice(index, 1)
            }
            setFieldSchema(updatedComponents)
        }
    }

    /**
     * Updating the field width for any INPUT
     * @param {*} event: Width select trigger event
     */
    const updateFieldWidth = (event) => {
        setSelectedWidth(event)
        UpdateComponentToPreview({ "id": fieldId }, "width", parseInt(event.value))
    }

    /**
     * Updating the field required for any INPUT
     * @param {*} event: Width select trigger event
     */
    const updateFieldRequirement = () => {
        setActiveToggle(!activeToggle)
        UpdateComponentToPreview({ "id": fieldId }, "mandatory", !activeToggle)
    }

    /**
     * Updating header type for TITLE input
     * @param {*} event: Header select trigger event
     */
    const updateHeaderCategory = (event) => {
        setSelectedHeader(event)
        UpdateComponentToPreview({ "id": fieldId }, "category", event.value)
    }

    // The required toggle swith
    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} />
                <span className="super-admin-slider super-admin-round"></span>
            </label>
        );
    };

    return (
        <Row className='no-gutter input-box'>
            <Col md={1} style={{ padding: 0, width: "fit-content" }} className='flex-row-center-center'>
                <div {...props.provided.dragHandleProps} className="field-dragger"><Icon.GripVertical /></div>
            </Col>
            <Col md={11} style={{ padding: 0 }}>
                <Row className='no-gutter'>
                    <Col md={4}>
                        <Select
                            options={inputOptions}
                            value={selectedInput}
                            onChange={(event) => setSelectedInput(event)}
                            components={{ Control: IconControl, Option: IconOption }}
                            placeholder={""}
                            aria-label="Default"
                            autosize={true}
                            className='custom-select '
                            classNamePrefix="react-select"
                        />
                    </Col>
                    {
                        selectedInput.value === "header" ?
                            <>
                                <Col md={3}>
                                    <Select
                                        options={headerOptions}
                                        value={selectedHeader}
                                        defaultValue={headerOptions[0]}
                                        onChange={(event) => updateHeaderCategory(event)}
                                        placeholder={""}
                                        aria-label="Default"
                                        autosize={true}
                                        className='custom-select '
                                        classNamePrefix="react-select"
                                    />
                                </Col>
                                <Col md={5}>
                                    <div className="mb-3">
                                        <input type="text" className="form-control move-left custom-input" id="formTitle" aria-describedby="emailHelp"
                                            placeholder={"Untitled label"}
                                            value={label}
                                            onChange={event => {
                                                setLabel(event.target.value)
                                                UpdateComponentToPreview({ "id": fieldId }, "label", event.target.value)
                                            }}
                                        />
                                    </div>
                                </Col>
                            </> :
                            ["checkbox", "radio"].includes(selectedInput.value) ? <></> :
                                <Col md={8}>
                                    <div className="mb-3">
                                        <input type="text" className="form-control move-left custom-input" id="formTitle" aria-describedby="emailHelp"
                                            placeholder={"Untitled label"}
                                            value={label}
                                            onChange={event => {
                                                setLabel(event.target.value)
                                                UpdateComponentToPreview({ "id": fieldId }, "label", event.target.value)
                                            }}
                                        />
                                    </div>
                                </Col>
                    }
                    <Col md={12}>
                        {
                            INPUT_MAP[selectedInput.id]
                        }
                    </Col>
                </Row>
                <Row className='no-gutter flex-row-space-center' style={{ borderTop: "1px solid lightgray", padding: "10px 0px 0px 0px", marginTop: "10px" }}>
                    <Col md={2}>
                        <div style={{ width: "fit-content" }}>
                            {/* <Icon.SquareHalf style={{ fontSize: 20, color: "var(--theme1_primary)", width: "fit-content", paddingRight: 20 }} /> */}
                            <Icon.Trash style={{ fontSize: 20, color: "var(--theme1_primary)", width: "fit-content", cursor: "pointer", paddingRight: 20 }} onClick={() => RemoveComponentToPreview({ "id": fieldId }, true)} />
                        </div>
                    </Col>
                    <Col md={3}></Col>
                    <Col md={4} className={"flex-row-center-center"}>
                        {selectedInput.value !== "checkbox" ?
                            <Select
                                options={widthOptions}
                                value={selectedWidth}
                                defaultValue={widthOptions[0]}
                                onChange={(event) => updateFieldWidth(event)}
                                placeholder={""}
                                aria-label="Default"
                                autosize={true}
                                // menuPosition="fixed"
                                className='custom-select '
                                classNamePrefix="react-select"
                            />
                            : <></>}
                    </Col>
                    <Col md={3} className={"flex-row-center-center"}>
                        {selectedInput.value !== "checkbox" ?
                            <div style={{ width: "fit-content" }}>
                                Required &nbsp;
                                <Switch
                                    isToggled={activeToggle}
                                    onClick={() => updateFieldRequirement()}
                                />
                            </div> : <></>}
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}


export default InputBox;